import { useEffect, useState, useCallback } from "react";

export const usePaymentTypes = () => {
	const [paymentTypes, setPaymentTypes] = useState([]);
	const [loadingPaymentTypes, setLoadingPaymentTypes] = useState(false);
	const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

	const fetchPaymentTypes = useCallback(async () => {
		try {
			setLoadingPaymentTypes(true);
			const token = localStorage.getItem("access_token");
			const response = await fetch(`${API_BASE_URL}/api/v1/payment-types`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`
				}
			});

			const data = await response.json();

			if (data?.success && Array.isArray(data.data)) {
				const transformed = data.data.map((payment) => ({
					value: String(payment.id),
					label: payment.name,
					type: payment.type,
					type_display: payment.type_display
				}));
				setPaymentTypes(transformed);
				return transformed;
			}

			// Fallback
			const fallback = [
				{ value: "2", label: "Credit Card", type: "card", type_display: "Credit Card" },
				{ value: "cash", label: "Cash", type: "cash", type_display: "Cash" },
				{ value: "debit_card", label: "Debit Card", type: "card", type_display: "Debit Card" },
				{ value: "bank_transfer", label: "Bank Transfer", type: "bank", type_display: "Bank Transfer" },
				{ value: "mobile_payment", label: "Mobile Payment", type: "mobile", type_display: "Mobile Payment" },
				{ value: "check", label: "Check", type: "check", type_display: "Check" }
			];
			setPaymentTypes(fallback);
			return fallback;
		} catch {
			const fallback = [
				{ value: "2", label: "Credit Card", type: "card", type_display: "Credit Card" },
				{ value: "cash", label: "Cash", type: "cash", type_display: "Cash" },
				{ value: "debit_card", label: "Debit Card", type: "card", type_display: "Debit Card" },
				{ value: "bank_transfer", label: "Bank Transfer", type: "bank", type_display: "Bank Transfer" },
				{ value: "mobile_payment", label: "Mobile Payment", type: "mobile", type_display: "Mobile Payment" },
				{ value: "check", label: "Check", type: "check", type_display: "Check" }
			];
			setPaymentTypes(fallback);
			return fallback;
		} finally {
			setLoadingPaymentTypes(false);
		}
	}, [API_BASE_URL]);

	useEffect(() => {
		fetchPaymentTypes();
	}, [fetchPaymentTypes]);

	return { paymentTypes, loadingPaymentTypes, reloadPaymentTypes: fetchPaymentTypes };
};


